(function () {
  function initImageGrid() {
    // Desktop-only: the 2-col grid for images 4+ applies at >=990px (see jb-global-cards.css).
    // On mobile the Splide carousel is active and moving slides out of its list breaks it
    // (slides 4+ become unreachable/blank). So never wrap below 990px.
    if (window.matchMedia('(max-width: 989px)').matches) return;

    var list = document.querySelector('.splide__gallery[class*="splide__gallery-"]');
    if (!list) return;
    if (list.querySelector(':scope > .jb-grid-wrapper')) return;

    var slides = Array.from(list.querySelectorAll(':scope > .splide__slide'));
    if (slides.length <= 3) return;

    // Wrap slides 4+ in a grid wrapper
    var gridSlides = slides.slice(3);
    var wrapper = document.createElement('div');
    wrapper.className = 'jb-grid-wrapper';
    list.insertBefore(wrapper, gridSlides[0]);
    gridSlides.forEach(function(s) { wrapper.appendChild(s); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initImageGrid);
  } else {
    initImageGrid();
  }
})();
